import { Box, Grid, Stack, TextField, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import SideDrawer from "../../components/SideDrawer";
import CountDownTimer from "../../components/SmallComponents/Timer";
import { AppContext, serverUrl } from "../../utils";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import {
  StyledButton,
  ToastNotify,
} from "../../components/SmallComponents/AppComponents";
import axios from "axios";
import Loading from "../../components/SmallComponents/loading";
import { useSwitchNetwork } from "wagmi";
import { contractWriteFunction } from "../../ConnectivityAssets/hooks";

const headingStyle = {
  fontFamily: "Saira Semi Condensed",
  fontWeight: 700,
  fontSize: { xs: "24px", sm: "30px" },
  lineHeight: "36px",
  letterSpacing: "1px",
  textAlign: "center",
  color: "#ffffff",
  textTransform: "uppercase",
};

const StyledInput = ({ ...props }) => {
  return (
    <TextField
      {...props}
      sx={{
        // boxShadow: "0px 3px 22px 0px #505050",
        background: "transparent",
        borderRadius: "7px",
        border: "1px solid #ffffff",
        width: "100%",
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
        },

        input: {
          "&::placeholder": {
            color: "#ffffff !important",
            opacity: 1,
          },
          padding: { xs: "16px 16px", sm: "18px 20px" },
          color: "#ffffff",
          fontSize: "13px",
          fontWeight: "600",
          fontFamily: "Montserrat",
        },
      }}
    />
  );
};

function PointsExchange() {
  const oneTokenPrice = 0.1;
  const {
    account,
    tweetHashTagsData,
    userDatabaseId,
    setTweetHashTagsData,
    chainId,
  } = useContext(AppContext);
  const { switchNetwork } = useSwitchNetwork();
  const [pointsAmount, setPointsAmount] = useState("");
  const [tokenAmount, setTokenAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const showAlert = (message, severity = "error") => {
    setAlertState({
      open: true,
      message,
      severity,
    });
  };

  const handleInputChange = (event) => {
    const input = event.target.value;
    const newValue = input?.replace(/[^0-9.]/g, "");
    setPointsAmount(newValue);
  };

  useEffect(() => {
    if (pointsAmount && +pointsAmount > 0) {
      setTokenAmount(parseFloat(oneTokenPrice * +pointsAmount)?.toFixed(2));
    } else {
      setTokenAmount(0);
    }
  }, [pointsAmount]);

  const claimHandler = async () => {
    const totalUserPoints =
      +tweetHashTagsData?.postPoints +
      +tweetHashTagsData?.viewsPoints +
      +tweetHashTagsData?.commentsPoints +
      +tweetHashTagsData?.likesPoints +
      +tweetHashTagsData?.retweetPoints +
      +tweetHashTagsData?.quotePoints -
      +tweetHashTagsData?.claimPoints;
    if (!account) {
      return showAlert("Error! Please connect your wallet.");
    }
    if (!pointsAmount || +pointsAmount <= 0) {
      return showAlert("Error! Please Enter Points.");
    }
    if (+totalUserPoints < +pointsAmount) {
      return showAlert("Error! You don't have enough points.");
    }
    if (chainId !== 1) {
      switchNetwork?.(1);
    }
    try {
      setLoading(true);
      await contractWriteFunction("exchangePoints", [+pointsAmount]);
      const { data } = await axios.put(
        `${serverUrl}/add_claim_points/${userDatabaseId}`,
        {
          claimPoints: +pointsAmount,
        }
      );
      setTweetHashTagsData({
        ...tweetHashTagsData,
        claimPoints: data?.claimPoints,
      });
      setPointsAmount("");
      setLoading(false);
      showAlert("Points Claimed Successfully", "success");
    } catch (e) {
      if (e?.shortMessage) {
        showAlert(e?.shortMessage);
      }
      setLoading(false);
    }
  };

  return (
    <SideDrawer>
      <Loading loading={loading} />
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Box>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Saira Semi Condensed",
            fontWeight: 600,
            mb: 2,
            fontSize: { xs: "18px", sm: "24px" },
            lineHeight: "30px",
            letterSpacing: "1px",
            textAlign: "left",
            color: "#ffffff",
          }}
        >
          Epoch 1
        </Typography>
        <Typography
          variant="h1"
          sx={{
            fontFamily: "Saira Semi Condensed",
            fontWeight: 700,
            fontSize: { xs: "30px", sm: "40px" },
            lineHeight: "50px",
            letterSpacing: "1px",
            textAlign: { xs: "center", md: "left" },
            color: "#ffffff",
            textTransform: "uppercase",
          }}
        >
          Point Exchange will open{" "}
        </Typography>
        <Stack
          my={{ xs: 2, md: 3 }}
          justifyContent="center"
          alignItems={"center"}
          flexDirection={"row"}
          mr={{ xs: 0, md: 9 }}
        >
          <CountDownTimer time={1717693200} />
        </Stack>
      </Box>

      <Grid container justifyContent={"center"} my={3} pr={{ xs: 0, md: 9 }}>
        <Grid item xs={12} sm={10}>
          <Box
            sx={{
              border: "5px solid #ffffff",
              borderRadius: "10px",
              py: 2,
              px: 3,
            }}
          >
            <Typography mb={3} variant="h3" sx={headingStyle}>
              Exchange
            </Typography>

            <Stack
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                my: 2,
              }}
            >
              <Box
                sx={{
                  height: "2px",
                  background: "#ffffff",
                  flexGrow: 1,
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mx: { xs: 1, md: 0.5, lg: 1, xl: 1 },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: { xs: "10px", sm: "12px" },
                    textAlign: "center",
                    fontWeight: "700",
                    color: "#ffffff",
                    fontFamily: "Saira Semi Condensed",
                    textTransform: "uppercase",
                  }}
                >
                  10 points = 1 token
                </Typography>
              </Box>
              <Box
                sx={{
                  height: "2px",
                  background: "#ffffff",
                  flexGrow: 1,
                }}
              />
            </Stack>
            <Stack my={2} gap={0.5}>
              <Stack
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mx: 0.5,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: { xs: "10px", sm: "12px" },
                    fontWeight: "700",

                    color: "#ffffff",
                    fontFamily: "Saira Semi Condensed",
                    textTransform: "uppercase",
                  }}
                >
                  Points
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: { xs: "10px", sm: "12px" },
                    fontWeight: "700",
                    color: "#ffffff",
                    fontFamily: "Saira Semi Condensed",
                    textTransform: "uppercase",
                  }}
                >
                  {+tweetHashTagsData?.postPoints +
                    +tweetHashTagsData?.viewsPoints +
                    +tweetHashTagsData?.commentsPoints +
                    +tweetHashTagsData?.likesPoints +
                    +tweetHashTagsData?.retweetPoints +
                    +tweetHashTagsData?.quotePoints -
                    +tweetHashTagsData?.claimPoints}
                </Typography>
              </Stack>
              <StyledInput
                type="text"
                placeholder="Enter Points"
                value={pointsAmount}
                onChange={handleInputChange}
              />
            </Stack>
            <Stack alignItems={"center"}>
              <ArrowCircleDownIcon
                sx={{
                  fontSize: "40px",
                  color: "#ffffff",
                }}
              />
            </Stack>
            <Stack gap={0.5} mt={-0.8}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: { xs: "10px", sm: "12px" },
                  fontWeight: "700",
                  mx: 0.5,
                  color: "#ffffff",
                  fontFamily: "Saira Semi Condensed",
                  textTransform: "uppercase",
                }}
              >
                Tokens
              </Typography>

              <StyledInput
                type="number"
                placeholder="0"
                value={tokenAmount > 0 ? tokenAmount : "0"}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Stack>
            <Stack mt={3} mb={1}>
              <StyledButton width="100%" onClick={claimHandler}>
                Claim
              </StyledButton>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </SideDrawer>
  );
}

export default PointsExchange;
